import React, {Fragment} from "react";
import image from '../../../images/situation/luikbreedte/luikbreedte.jpg'

export default function Breedte(props) {
    return <Fragment>
        <div className="addtextMore">
            Hier kunt u invullen wat de breedte van de luiken is, in milimeters.<br/>
            <br/>
            Voorbeeld:
            <br/>
            Als uw luik 60 cm breed is, voert u 600 in als waarde.
        </div>
        <img className="explainImage" src={image} alt=""/>
    </Fragment>;
}